var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-result"},[_c('h1',{staticClass:"no-result__title no-result__title_question",class:`no-result__title_question-order`},[_vm._v(" No Data ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }